import React from 'react';
import { Utensils, Phone, Leaf } from 'lucide-react';

const goldText = {
  background: 'linear-gradient(135deg, #fde68a 0%, #fbbf24 45%, #b45309 100%)',
  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
};

export const getMenuCourses = menu =>
  (menu?.courses || [])
    .map(c => ({ name: (c.name || '').trim(), dishes: (c.dishes || '').split('\n').map(d => d.trim()).filter(Boolean) }))
    .filter(c => c.name || c.dishes.length);

export const isMenuReady = menu => !!menu?.published && getMenuCourses(menu).length > 0;

const Divider = () => (
  <div className="flex items-center justify-center gap-3 my-2" aria-hidden>
    <span className="h-px w-16" style={{ background: 'linear-gradient(90deg, transparent, #fbbf24)' }} />
    <span style={{ color: '#fbbf24', fontSize: '10px' }}>◆</span>
    <span className="h-px w-16" style={{ background: 'linear-gradient(90deg, #fbbf24, transparent)' }} />
  </div>
);

function WaButton({ waLink }) {
  if (!waLink) return null;
  return (
    <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="capodanno-menu-wa"
      className="inline-flex items-center gap-2 font-manrope font-700 text-sm rounded-full transition-transform duration-300 hover:-translate-y-0.5"
      style={{ padding: '0.8rem 1.4rem', background: 'rgba(37,211,102,0.12)', border: '1px solid rgba(37,211,102,0.45)', color: '#4ade80' }}>
      <Phone size={15} /> Chiedi info sul menu su WhatsApp
    </a>
  );
}

function MenuTeaser({ waLink }) {
  return (
    <div className="text-center py-6" data-testid="capodanno-menu-teaser">
      <p className="font-playfair italic text-gray-300 text-lg md:text-xl mb-2">Lo chef sta preparando qualcosa di speciale…</p>
      <p className="font-playfair font-900 mb-6" style={{ ...goldText, fontSize: 'clamp(2rem, 5vw, 3.4rem)' }}>Menu svelato a breve</p>
      <WaButton waLink={waLink} />
    </div>
  );
}

export function CapodannoMenu({ menu, waLink }) {
  const ready = isMenuReady(menu);
  const courses = getMenuCourses(menu);
  return (
    <section id="capodanno-menu" className="relative z-10 px-4 pt-16" data-testid="capodanno-menu-section">
      <div className="max-w-4xl mx-auto relative rounded-[2rem] p-8 md:p-14 overflow-hidden" style={{
        background: 'radial-gradient(ellipse at top, rgba(251,191,36,0.14), rgba(20,8,25,0.95) 60%)',
        border: '1px solid rgba(251,191,36,0.45)',
        boxShadow: '0 30px 90px rgba(0,0,0,0.6), 0 0 60px rgba(251,191,36,0.12), inset 0 0 0 8px rgba(10,5,20,0.6), inset 0 0 0 9px rgba(251,191,36,0.25)',
      }}>
        <div className="text-center mb-8">
          <Utensils size={28} className="mx-auto mb-3" style={{ color: '#fbbf24' }} />
          <p className="font-manrope font-700 uppercase tracking-[0.4em] text-[11px] mb-3" style={{ color: '#fbbf24' }}>Cena di Gala · 31.12</p>
          <h2 className="font-playfair font-900" style={{ ...goldText, fontSize: 'clamp(2.4rem, 6vw, 4.2rem)', lineHeight: 1 }} data-testid="capodanno-menu-title">Il Menu</h2>
          <Divider />
        </div>

        {!ready ? <MenuTeaser waLink={waLink} /> : (
          <>
            <div className="space-y-10" data-testid="capodanno-menu-courses">
              {courses.map((c, i) => (
                <div key={i} className="text-center" data-testid={`capodanno-menu-course-${i}`}>
                  {c.name && (
                    <h3 className="font-manrope font-800 uppercase tracking-[0.35em] text-xs md:text-sm mb-4" style={{ color: '#fbbf24' }}>{c.name}</h3>
                  )}
                  <ul className="space-y-2">
                    {c.dishes.map((d, j) => (
                      <li key={j} className="font-playfair text-white text-lg md:text-2xl leading-snug">{d}</li>
                    ))}
                  </ul>
                  {i < courses.length - 1 && <div className="mt-8"><Divider /></div>}
                </div>
              ))}
            </div>
            {menu?.notes?.trim() && (
              <p className="mt-10 mx-auto max-w-xl text-center font-manrope text-sm text-gray-400 flex items-start justify-center gap-2" data-testid="capodanno-menu-notes">
                <Leaf size={15} className="shrink-0 mt-0.5" style={{ color: '#86efac' }} />
                <span>{menu.notes}</span>
              </p>
            )}
            <div className="mt-8 text-center"><WaButton waLink={waLink} /></div>
          </>
        )}
      </div>
    </section>
  );
}
